import { useUserStore } from "../../state";
import { useCompanyStore } from "../../state/useCompanyStore";
import TourGuideComponent from "./SideBar";

export const useListInvoiceTourGuide = () => {
  const { setListInvoice, updateProfile, company: user } = useCompanyStore();
  const tourGuideOptions = {
    showProgress: false,
    disableBeacon: true,
    styles: {
      tooltip: { background: "#ffffff" },
      beaconInner: { background: "#ffffff" },
    },
    placement: "bottom" as const,
    locale: {
      skip: (
        <span
          onClick={() => {
            setListInvoice(false);
          }}
          className="text-[#344054]"
        >
          Skip
        </span>
      ),
      next: <span className="text-[#ffffff] bg-transparent">Next</span>,
    },
  };
  const listInvoiceTourGuide = [
    {
      target: "#list-archive-button",
      content: (
        <TourGuideComponent
          body="Click here to view and manage all your recurring invoices in one place."
          progress="Step 1 of 2"
          title="Manage Recurring Invoices"
        />
      ),
      hideBackButton: true,
      scrollOffset: 80,
      ...tourGuideOptions,
    },
    {
      target: "#list-metric-button",
      content: (
        <TourGuideComponent
          body="Click this to hide the overview metrics and focus solely on the detailed invoice table."
          progress="Step 2 of 2"
          title="Hide Metrics"
        />
      ),
      placement: "bottom" as const,
      locale: {
        skip: <span className="text-[#344054]">Skip</span>,
        next: <span className="text-[#ffffff] bg-transparent">Next</span>,
        last: (
          <span
            onClick={() => {
              setListInvoice(false);
              updateProfile({
                prefs: {
                  ...user.prefs,
                  isFirstInvoice: false,
                },
              });
            }}
            className="text-[#ffffff] bg-transparent"
          >
            Finish up
          </span>
        ),
      },
      showProgress: false,
      scrollOffset: 80,
      styles: {
        tooltip: { background: "#ffffff" },
        beaconInner: { background: "#ffffff" },
      },
    },
  ];

  return { listInvoiceTourGuide };
};
